// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"711da0ec","990":"4cb1fd8c"}[chunkId] + ".chunk.js";
};